module.exports = __webpack_public_path__ + "nc_static/media/notificationAnalysis.6ae0981e.svg";